import React, { useEffect, useState } from 'react'
import GenerateIcon, { IconTypes } from './GenerateIcon'

export interface ITab {
    name: string,
    icon: IconTypes,
    title: string,
    component: () => JSX.Element
}

interface ITabsProps {
    activeTab: string,
    updateActivateTab: (name: string) => void,
    tabs: ITab[],
    availableTabs: string[],
}



export default function Tabs(props: ITabsProps) {

    const { activeTab, tabs, availableTabs, updateActivateTab } = props

    const hasStep = (step: string): boolean => {
        return availableTabs.includes(step)
    }

    const [stepLineLeft, setStepLineLeft] = useState<number>(0)
    const [stepLineWidth, setStepLineWidth] = useState<number>(0)

    /**
     * Update Available step
     */
    // const addAvailableStep = (step: string) => {
    //     setAvailableSteps(prev =>
    //       prev.includes(step) ? prev : [...prev, step]
    //     )
    // }

    // const removeAvailableStep = (step: string) => {
    //     setAvailableSteps(prev =>
    //       prev.filter(s => s !== step)
    //     )
    // }

    useEffect(() => {
        if (activeTab){
            const elem = document.getElementById("step-" + activeTab)
            if (elem){
                setStepLineWidth(elem.clientWidth)
                setStepLineLeft(elem.offsetLeft)
            }
        }
    }, [activeTab])

    return(
        <div className="tabs-container">

            <div className="new-items-requests-steps">
                <div className="steps-of-user-profile-page-container">
                    <div className="content-of-steps-of-user-profile-page-container">
                        {tabs.map((step, index) => {

                            const returnClassName = (name: string) => {
                                if (hasStep(step.name)){
                                    return name
                                }

                                return name + " disabled"
                            }

                            return(
                                <div id={"step-" + step.name} onClick={() => {
                                    updateActivateTab(step.name)
                                }} className={activeTab === step.name ? returnClassName("single-step-of-user-profile active") : returnClassName("single-step-of-user-profile")} key={index}>
                                    <div className="content-of-single-step-of-user-profile">
                                        <GenerateIcon icon={step.icon} />
                                        <p>{step.title}</p>
                                    </div>
                                </div>
                            )
                        })}
                        <div className="step-line" style={{ left: stepLineLeft, width: stepLineWidth }}></div>
                    </div>
                </div>

                <div className="active-step-content-container">
                    <div className="content-of-active-step-content-container">
                        {tabs.map((step) => {
                            if (step.name === activeTab){
                                return step.component()
                            }

                            return <></>
                        })}
                    </div>
                </div>
            </div>

        </div>
    )
}